import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import * as moment from 'moment-timezone';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  services: any;
  startTour = true;
  public meterErrorDueData = new Subject<any>();
  public assetMasterErrors = new Subject<any>();
  public dropAndPicksWoCount = new Subject<any>();
  public customerInspectonDueCount = new Subject<any>();
  public workOrderCountByStatus = new Subject<any>();
  public pendingDispatchWOCount = new Subject<any>();
  public WOStatusForNewDashBoardCustomerView = new Subject<any>();
  public matrixValue = new Subject<any>();
  public ActiveAssetsCountForDashboardValue = new Subject<any>();
  public overAndPmDueRegularitydata = new Subject<any>();
  public operationalAsset = new Subject<any>();
  public nonOperationalAsset = new Subject<any>();
  public inspectionOverDuePrimary = new Subject<any>();
  public nextStepData = new Subject<any>();
  public checkIsDemo: boolean = false;
  public dashboardRefresh = new Subject<any>();
  public roCounts = new Subject<any>();


  constructor(private http: HttpClient, private router: Router) { }

  setServices(services) {
    this.services = services;
  }

  getServices() {
    return this.services;
  }

  getServiceTypes(): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}api/vendorSearch/GetVendorServiceSearch`);
  }

  getSubServiceTypes(service): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}api/vendorSearch/GetVendorSubServiceSearch/${service}`);
  }

  setStartTour(startTour) {
    sessionStorage.setItem('isTourShow', startTour);
  }

  getStartTour() {
    return sessionStorage.getItem('isTourShow');
  }

  updateDoNotShowTour() {
    let customerInfoId = sessionStorage.getItem('customerUserInformationId');
    return this.http.get(environment.baseUrl + 'api/customers/updateDoNotShowTour/' + customerInfoId);
  }

  getVehicleType(service, subService): Observable<any> {
    const body = {
      service: service,
      subService: subService
    }
    return this.http.post<any>(`${environment.baseUrl}api/getVehicleType`, body);
  }

  checkLoggedInUser() {
    if (sessionStorage.getItem('currentUserEmail') != null) {
      this.router.navigate(['/pages']);
    }
  }

  getSubCustomerByExternalLocationId(intExternalLocationId): Observable<any> {
    const body = {
      custKey: sessionStorage.getItem('legacyCustomerKeyId'),
      shipTo: intExternalLocationId
    }
    return this.http.post<any>(`${environment.baseUrl}getSubCustomerByExternalLocationId`, body);
  }

  getLocationOptionsBySubCustomer(intSubCustomerKey): Observable<any> {
    return this.http.get(environment.baseUrl + 'getLocationOptionsBySubCustomer/' + intSubCustomerKey);
  }

  getAssetCountByCustomer(customerKey: any): Observable<any> {
    return this.http.get<any>(environment.baseUrl + `getAssetCountByCustomer/${customerKey}`);
  }

  //Triggers to set data on dashboard based on hierarchy selected
  setMeterErrorDueData(data: any) {
    this.meterErrorDueData.next(data);
  }

  setAssetMasterErrors(data: any) {
    this.assetMasterErrors.next(data);
  }

  setDropAndPicksWoCount(data: any) {
    this.dropAndPicksWoCount.next(data);
  }

  setCustomerInspectonDueCount(data: any) {
    this.customerInspectonDueCount.next(data);
  }

  setWorkOrderCountByStatus(data: any) {
    this.workOrderCountByStatus.next(data);
  }

  setPendingDispatchWOCount(data: any) {
    this.pendingDispatchWOCount.next(data);
  }

  setWOStatusForNewDashBoardCustomerView() {
    this.WOStatusForNewDashBoardCustomerView.next();
  }

  setmatrixValue() {
    this.matrixValue.next();
  }

  setActiveAssetsCountForDashboardValue(data: any) {
    this.ActiveAssetsCountForDashboardValue.next(data);
  }

  setOverAndPmDueRegularitydata(data: any) {
    this.overAndPmDueRegularitydata.next(data);
  }

  setOperationalAsset(data: any) {
    this.operationalAsset.next(data);
  }

  setNonOperationalAsset(data: any) {
    this.nonOperationalAsset.next(data);
  }

  setInspectionOverDuePrimary(data: any) {
    this.inspectionOverDuePrimary.next(data);
  }

  /***
  * Set Demo steps
  ***/
  setDemoNextStep(message: any) {
    this.nextStepData.next(message);
  }

  setDashboardRefresh(data: any) {
    this.dashboardRefresh.next(data);
  }

  /***
  * check is this a demo page
  ***/
  checkIsDemoPage(message: boolean) {
    this.checkIsDemo = message;
  }

  /***
  * get isDemo is set
  ***/
  getIsDemo() {
    return this.checkIsDemo;
  }

  /***
  * Send demo email to logged in customer
  * @params  body array
  * @return array response.
  ***/
  sendDemoEmail(body: any): Observable<any> {

    const userDetails = JSON.parse(sessionStorage.getItem('userDetails'));
    const postData = {
      name: userDetails.firstname + ' ' + userDetails.lastname,
      email: userDetails.email,
      phoneNumber: sessionStorage.getItem('callerPhoneNo'),
      subject: body.subject,
      message: body.message
    };
    return this.http.post<any>(`${environment.baseUrl}api/customers/sendTourEmail`, postData);
  }

  /***
  * Check demi is completed or not
  * @params  body array
  * @return array response.
  ***/
  checkIsDemoCompleted(): Observable<any> {

    const userDetails = JSON.parse(sessionStorage.getItem('userDetails'));
    return this.http.get(environment.baseUrl + 'api/customers/updateIsDemoANDAgreedStatus/' + userDetails.email);
  }

  convertToEST(time) {
    if (time == null || time == '0000-00-00 00:00:00' || time == '-') {
      return time;
    }
    time = moment(time).format('YYYY-MM-DD HH:mm');
    var formatDate = moment.tz(time, moment.tz.guess());
    return formatDate.tz('America/New_York').format('YYYY-MM-DD HH:mm');
  }

  getServiceType(): Observable<any> {
    return this.http.get(`${environment.baseUrl}api/vendorSearch/GetVendorServiceSearch`);
  }


  setRoCounts() {
    this.roCounts.next();
  }
}
